<div class="dialog">
    <h2 mat-dialog-title class="mat-dialog-title">
        {{'commondeletDialog.confirmation' | translate}}
    </h2>
    <div class="container" fxLayout="column" fxLayoutAlign="center center">
        <div *ngIf="data.target=='pageDelete'; else otherDelete">
            <p>{{'commondeletDialog.pageDeleted' | translate}}</p>
            <P>{{'commondeletDialog.suretoContinue' | translate}}</P>
        </div>
        <ng-template #otherDelete>
            <p>{{'commondeletDialog.suretoDelete' | translate: {target:data.target} }}</p>
            <mat-list>
                <mat-list-item *ngFor="let deletename of data.deleteNames">
                    <p class="delete">{{deletename}}</p>
                </mat-list-item>
            </mat-list>
        </ng-template>
    </div>
    <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
        <mat-dialog-actions>
            <button mat-button color="primary" mat-dialog-close>{{'commondeletDialog.cancel' | translate}}</button>
            <button mat-raised-button color="warn" (click)="delete()">{{'commondeletDialog.delete' | translate}}</button>
        </mat-dialog-actions>
    </div>
</div>
